import { isNil } from "lodash";

export const calculateYield = (spend: number | undefined, revenue: number | undefined) => {
  if (spend === 0 || isNil(spend) || isNil(revenue)) return null;
  return revenue / spend;
};
